import React from "react";
import { Row, Col, Link, Popover } from "../../common/UIComponents";
import CustomerOrderDetails from "./CustomerOrderDetails";
import Copyable from "../common/Copyable";
import { ellipseText, isEmpty, doFormate } from "../../common/Common";
import I18n from "../../common/I18n";
import PropTypes from "prop-types";
import { colorStatusStyle, colorTagToolTip } from "../dispatches/helpers";

const OrderFieldDisplay = ({
  data,
  toDisplay,
  showTriggerEdit = false,
  editClick = () => { },
  refreshCallback = () => { },
  showEditIcon = false,
  tootlTipDelay = null,
  showPopupContainer = false,
  tab = null,
  charsToLimit = 10,
  showOrderDetailsByReference = false,
}) => {
  const isHawbOrMawb = ["hawb", "mawb"].includes(toDisplay);
  const isReference = ["reference_1", "reference_2"].includes(toDisplay);
  const isReferenceWithOrderLink = showOrderDetailsByReference && isReference;
  const dispatchColorObj = _.get(data, 'color_tags[0]', null);

  const renderCopyable = (text) =>
    text && (
      <div style={{ flexShrink: 0 }}>
        <Copyable text={text} />
      </div>
    );

  const renderHawbMawbOrReference = () =>
    showTriggerEdit && !isEmpty(data[toDisplay]) ? (
      <Row type="flex" gutter={8} style={{ flexFlow: "unset" }} align="middle">
        {
          <Col style={{ textOverflow: 'ellipsis', overflow: 'hidden' }}>
              <Link
                onClick={() => editClick(data.id)}
                style={colorStatusStyle(dispatchColorObj)}
              >
                <span className="ellipsis-text" style={{ display: 'inline-block',maxWidth: '120px' }}>
                {colorTagToolTip(
                  dispatchColorObj,
                  data[toDisplay]
                  // ellipseText(
                    //   data[toDisplay],
                    //   charsToLimit,
                    //   true,
                    //   tootlTipDelay,
                    //   showPopupContainer
                    // )
                  )}
                  </span>
              </Link>
          </Col>
        }
        &nbsp;
        {renderCopyable(data[toDisplay])}
      </Row>

    ) : (
          <CustomerOrderDetails
            displayedItem={data[toDisplay]}
            toShow={toDisplay}
            order_no={data.customer_order_number}
            order={{
              id: data.id,
              color_tags: data.color_tags,
              customer_order_number: data.customer_order_number,
            }}
            showEdit={showEditIcon}
            editClick={() => editClick(data.id)}
            refreshCallback={refreshCallback}
            tab={tab}
            showPopupContainer={showPopupContainer}
            charsToLimit={charsToLimit}
        />
    )

  const renderReference = () => (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <Popover
        title={I18n.t("order.reference_details")}
        content={
          <div>
            {doFormate(data[`${toDisplay}_type`])} :{" "}
            {doFormate(data[toDisplay])}
          </div>
        }
        placement="topLeft"
        // getPopupContainer={
        //   showPopupContainer ? (triggerNode) => triggerNode.parentNode : null
        // }
        
        // To display the tooltip in the body and not in the parent div (some part getting hidden)
        getPopupContainer={(triggerNode) => document.body}
        mouseEnterDelay={tootlTipDelay}
      >
        <Col style={{ textOverflow: "ellipsis", overflow: "hidden" }}>
          {(!isEmpty(data[`${toDisplay}_type`]) || !isEmpty(data[toDisplay])) &&
            colorTagToolTip(
              dispatchColorObj,
              data[toDisplay]
            )
          }
        </Col>
      </Popover>
      {renderCopyable(data[toDisplay])}
    </div>
  );

  if (isHawbOrMawb || isReferenceWithOrderLink) {
    return renderHawbMawbOrReference();
  } else if (isReference) {
    return renderReference();
  }

  return null;
};

export default OrderFieldDisplay;

OrderFieldDisplay.propTypes = {
  data: PropTypes.object.isRequired,
  toDisplay: PropTypes.string.isRequired,
  showTriggerEdit: PropTypes.bool,
  editClick: PropTypes.func,
  refreshCallback: PropTypes.func,
  showEditIcon: PropTypes.bool,
  tootlTipDelay: PropTypes.number,
  showPopupContainer: PropTypes.bool,
  tab: PropTypes.string,
  charsToLimit: PropTypes.number,
  showOrderDetailsByReference: PropTypes.bool,
};

OrderFieldDisplay.defaultProps = {
  showTriggerEdit: false,
  editClick: () => { },
  refreshCallback: () => { },
  showEditIcon: false,
  tootlTipDelay: null,
  showPopupContainer: false,
  tab: null,
  charsToLimit: 10,
  showOrderDetailsByReference: false,
};
